import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import CustomCarouselSliders from "../../components/customslider/customslider";
import { BiSolidCategory } from "react-icons/bi";
import { FaSearch } from "react-icons/fa";
import { getLimitedImages } from "../../config/pageDetails";
import "./subcategory.css";

const CustomSlider = ({ slide }) => {
  const images = getLimitedImages(
    slide?.imageUrl,
    "subCategory",
    "cardImageLimit"
  );

  return (
    <div>
      <CustomCarouselSliders>
        {images.map((image, index) => (
          <img
            className="image-category-slider"
            key={index}
            src={image}
            alt={slide.name}
          />
        ))}
      </CustomCarouselSliders>
    </div>
  );
};

const SubCategoryPage = () => {
  const { t } = useContext(LanguageContext);
  const location = useLocation();
  const slide = location.state?.slide;

  const searchInputRef = React.useRef(null);

  const categoryId = slide?.categoryId;

  const navigate = useNavigate();

  const [subCategoryData, setSubCategoryData] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [metaData, setMetaData] = useState([]);
  const pageSize = 8;

  useEffect(() => {
    if (!slide) {
      navigate(`/category`);
      return;
    }

    if (!categoryId) {
      navigate(`/category`);
      return;
    }

    try {
      const parsedMeta =
        typeof slide.metaData === "string"
          ? JSON.parse(slide.metaData)
          : slide.metaData;

      setMetaData(Array.isArray(parsedMeta) ? parsedMeta : []);
    } catch (e) {
      console.error("Failed to parse slide.metaData", e);
      setMetaData([]);
    }

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/api/subcategories?offset=${currentPage}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ categoryId: slide.categoryId }),
          }
        );

        if (!response.ok) {
          console.error("Failed to fetch subcategory data");
          return;
        }

        const result = await response.json();
        setSubCategoryData(result.subCategories);
        setTotalCount(result.totalCount || 0);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, [categoryId, currentPage, navigate, slide]);

  const totalPages = Math.ceil(totalCount / pageSize);

  const handleMenuClick = (subCategory) => {
    navigate(`/products`, { state: { subCategory } });
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handleSearchClick = (e) => {
    //console.log("Search term click:", searchInputRef.current?.value);
  };

  const SearchBar = ({ placeholder = "Search here", inputRef }) => {
    return (
      <div className="searchbar-container-subcategory">
        <input
          className="searchbar-input-subcategory"
          type="text"
          placeholder={placeholder}
          ref={inputRef}
        />
        <FaSearch
          className="search-icon-subcategory"
          onClick={handleSearchClick}
        />
      </div>
    );
  };

  return (
    <div className="category-container">
      <div className="category-header">
        <BiSolidCategory className="category-icon" />
        <h2 className="category-header-title">
          {slide && slide.name ? slide.name : ""}
        </h2>
      </div>

      {metaData &&
        metaData.map((filterOption, index) => (
          <div key={index}>
            {filterOption.type === "searchbar" &&
              filterOption.isActive === true && (
                <div className="filter-section-category">
                  <SearchBar inputRef={searchInputRef} />
                </div>
              )}
          </div>
        ))}

      <div className="pagination-controls">
        <button
          className="card-button"
          onClick={handlePrev}
          disabled={currentPage === 0}
        >
          {t(`constants.Previous`)}
        </button>
        <span style={{ margin: "0 10px" }}>
          {t(`constants.Page`)} {currentPage + 1} {t(`constants.of`)}{" "}
          {totalPages}
        </span>
        <button
          className="card-button"
          onClick={handleNext}
          disabled={currentPage >= totalPages - 1}
        >
          {t(`constants.Next`)}
        </button>
      </div>
      <div className="category-grid">
        {subCategoryData &&
          subCategoryData.map((subCategory, index) => (
            <div className="category-card" key={index}>
              <CustomSlider slide={subCategory} />
              <div className="card-body">
                <div className="card-title">{subCategory.name}</div>
                <div className="card-description">
                  <b>Description: </b>
                  {subCategory.description}
                </div>
                <div className="card-description">
                  <b>Includes: </b>
                  {subCategory.includes}
                </div>
                <div className="card-description">
                  <b>Materials: </b>
                  {subCategory.materials}
                </div>
                <button
                  className="card-button"
                  onClick={() => handleMenuClick(subCategory)}
                >
                  {t(`constants.viewAll`)}
                </button>
              </div>
            </div>
          ))}
      </div>
      <div className="pagination-controls">
        <button
          className="card-button"
          onClick={handlePrev}
          disabled={currentPage === 0}
        >
          {t(`constants.Previous`)}
        </button>
        <span style={{ margin: "0 10px" }}>
          {t(`constants.Page`)} {currentPage + 1} {t(`constants.of`)}{" "}
          {totalPages}
        </span>
        <button
          className="card-button"
          onClick={handleNext}
          disabled={currentPage >= totalPages - 1}
        >
          {t(`constants.Next`)}
        </button>
      </div>
    </div>
  );
};

export default SubCategoryPage;
